import ApiConstants from '../constants/ApiConstants';
import http from "../http";

class PayScheduleService {
    static config = {
        limit: '1',
        currentPage: '1',
        order: 'desc',
        field: 'firstPayDate'
    }
    static getPaySchedule() {
        let url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_PAYSCHEDULELIST+`?limit=${PayScheduleService.config.limit}&currentPage=${PayScheduleService.config.currentPage}&order=${PayScheduleService.config.order}&field=${PayScheduleService.config.field}`
         return http.get(url)
            .catch((err: any) => {
                console.error('Error loading pay schedule: ', err);
                return Promise.reject(err);
            });
    }
    static updatePaySchedule(param){
        let url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.PAY_SCHEDULE + '/' +param._id
        return http.put(url,param)
    }
    static addPaySchedule(param){
        return http.post(ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.PAY_SCHEDULE,param)
    }
}

export default PayScheduleService;
